import Router from 'next/router'

import { useFeatureFlagContext } from 'utils/hooks/context/useFeatureFlagContext'

export const useMaintenancePelatihanMandiri = () => {
  const isServer = typeof window === 'undefined'

  const path = !isServer && Router?.pathname
  const { getFeatureByKey, status } = useFeatureFlagContext()

  const isLoading = status === 'loading'

  const isPelatihanMandiriOnMaintenance =
    getFeatureByKey('enableMaintenancePelatihanMandiri') &&
    path.includes('/pelatihan-mandiri')

  return {
    isOnMaintenance: isPelatihanMandiriOnMaintenance,
    isLoading,
  }
}
